import { CostType, TemplateAccountingCategory, ActivityModifier, PayBy } from '@/utils/Enumerations.js'

function rateForProduct (activity, product) {
  const hasDetail = activity.activityDetails.find(detail => detail.product.productId === product.productId)
  return hasDetail ? hasDetail.cost.rate : activity.baseCost?.rate
}

function signedRateAmount (activity, rate, distance) {
  const isReceivable = activity.activityTemplate.category === TemplateAccountingCategory.AccountsReceivable.value
  const usesDistance = activity.activityTemplate.modifier === ActivityModifier.DistanceTraveled.value
  const amount = usesDistance ? rate * distance : rate
  return isReceivable ? amount : -amount
}

export function hasPayByVolumeInventoryActivity (activities) {
  return (activities ?? []).some(activity => activity.activityTemplate.costType !== CostType.NonInventory.value &&
    activity.baseCost?.payBy === PayBy.Volume.value)
}

export function profitByProductMap (activities, products, distance) {
  const inventoryActivities = (activities ?? []).filter(activity => activity.activityTemplate.costType !== CostType.NonInventory.value)
  const profitByProduct = new Map()

  products.forEach(product => {
    const ratedActivities = inventoryActivities
      .map(activity => ({ activity, rate: rateForProduct(activity, product) }))
      .filter(({ rate }) => rate != null)

    if (ratedActivities.length === 0) return

    const profit = ratedActivities.reduce((total, { activity, rate }) => total + signedRateAmount(activity, rate, distance), 0)
    profitByProduct.set(product.productId, profit)
  })

  return profitByProduct
}
